import { IconButton } from "@mui/material";

import FilterIcon from "assets/icons/filter.svg?react";

import styles from "./DashboardWidget.module.css";
import DashboardWidgetItem from "components/Dashboard/DashboardWidgetItem";

const DashboardWidget = ({ title, variant, data, isLoading }) => {
    return (
        <div
            className={styles.dashboardWidget}
            data-testid={`dashboard-widget-${variant}`}
        >
            <h3 className={`${styles.dashboardWidgetTitle} ${styles[variant]}`}>
                {title}
            </h3>
            <ul className={styles.dashboardWidgetContent}>
                {isLoading ? (
                    <li className={styles.dashboardWidgetLoading}>
                        Loading...
                    </li>
                ) : data?.length === 0 ? (
                    <li className={styles.dashboardWidgetLoading}>
                        {variant === "toDoList"
                            ? "Nothing here - You're all caught up"
                            : variant === "courses"
                              ? "No courses available."
                              : variant === "noticeBoard"
                                ? "No notices available."
                                : "No items to display."}
                    </li>
                ) : (
                    data?.map((item, index) => (
                        <DashboardWidgetItem
                            key={index}
                            item={item}
                            variant={variant}
                        />
                    ))
                )}
            </ul>
        </div>
    );
};

export default DashboardWidget;
